export default __webpack_public_path__ + "static/media/contact-light.07e7a53f.svg";